import { useState } from 'react'
import styled from 'styled-components'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import useSetFocus from '../../hooks/useSetFocus'
import { removeLoginError } from '../../features/login/loginSlice'
import { useVerifyProfileMutation } from '../../features/api/apiSlice'
import { createLoginError } from '../../features/login/loginSlice'

const FormContent = () => {
  const [emailValue, setEmailValue] = useState("");
  
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleEmailChange(e){
    dispatch(removeLoginError())
    setEmailValue(e.target.value);
  }

  useSetFocus('input[type="email"]');

  const [verifyProfile, {isLoading}] = useVerifyProfileMutation()

  const canVerify = [emailValue].every(Boolean) && !isLoading

  async function handleVerifyProfile(e){
    e.preventDefault()

    if(canVerify){
      try{
        const result = await verifyProfile({email:emailValue}).unwrap()

        if(result?.Client_Profile_X === true){
          navigate('/')
        }
      }catch(err){
        if(err?.data?.Client_Profile_X === false){
          const error_message = `${err.data.message}. Please provide a valid profile recognized by AMRS`
          dispatch(createLoginError(error_message))
        }
        else if(err?.data?.detail[0]?.type === "value_error"){
          const error_message = `The entry is not a valid email address. Please provide a valid email`
          dispatch(createLoginError(error_message))
        }
        else{
          const error_message = `An error occured. Retry the entry again`
          dispatch(createLoginError(error_message))
        }
      }
    }
    else{
      const error_message = `The entry field cannot be empty. Please provide a valid email`
      dispatch(createLoginError(error_message))
    }
  }

  return (
    <Form >
      <div className="form-input">
        <input type="email" onChange={handleEmailChange} name='email' id='email' className='input-field' required />
        <label for="email" className={`input-label ${emailValue && 'fixed'}`}>Email</label>
      </div>
      <p>By clicking <b>"Verify"</b> you agree to our <Link to="/legal/terms-of-use">Terms of Use</Link> and our <Link to="/privacy-policy">Privacy Policy</Link>.</p>
      <button className='login-btn' onClick={handleVerifyProfile} disabled={isLoading}>Verify</button>
    </Form>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1em;
  margin: 2em auto;
  .form-input{
    position: relative;
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: .5em auto;
      &:focus-within .input-label{
        transform: translate(0, -.5em) scale(0.8);
      }
    .input-field{
      width: 90%;
      padding: .7em 1em;
      border: none;
      outline: none;
      border-bottom: 1px solid var(--color-muted-black-light);
      font-size: 1.1rem;
      &:focus{
        border-bottom: 2px solid var(--primary-color);
      }
    }
    .input-label{
      position: absolute; 
      pointer-events: none;
      transform: translate(0, .8em) scale(1);
      transform-origin: top left;
      transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
      color: var(--color-muted-black);
      font-size: 1rem;
      left: 1em;
    }
    .fixed{
      transform: translate(0, -.5em) scale(0.8);
    }
  }

  p{
    font-size: 0.8rem;
    width: 80%;
    a{
      color: var(--primary-color);
      &:hover{
        text-decoration: underline;
      }
    }
  }
  .login-btn{
    width: 80%;
    padding: 1em 1em;
    border: none;
    border-radius: 50px;
    outline: none;
    font-size: 1.1rem;
    background-color: var(--primary-color);
    color: var(--color-white);
    cursor: pointer;
    &:disabled{
      background-color: var(--color-muted-black-light);
    }
  }

  @media only screen and (min-width: 1200px) {
     .form-input{
      width: 70%;
     }
     p{
      width: 60%;
     }
     .login-btn{
      width: 60%;
     }
  }
`;

export default FormContent